import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-not-found-page',
  templateUrl: './forbidden-page.component.html',
  styleUrls: ['./forbidden-page.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForbiddenPageComponent {}
